export interface IProtectionPlanState {
    isLoading: boolean;
    protectionPlanData: IProtectionPlanResponse;
}

export const REQUEST_PROTECTION_PLAN = "REQUEST_PROTECTION_PLAN";
export const RECEIVE_PROTECTION_PLAN = "RECEIVE_PROTECTION_PLAN";

export interface IRequestProtectionPlanAction {
    type: typeof REQUEST_PROTECTION_PLAN;
}

export interface IReceiveProtectionPlanAction {
    protectionPlanData: IProtectionPlanResponse;
    type: typeof RECEIVE_PROTECTION_PLAN;
}

export interface IProduct {
    parent?: number;
    id: number;
    displayName?: string;
    description?: string;
    name: string;
    labelText: string;
    rowId: number;
    orderBy?: any;
    isAddOnService?: boolean;
}

export interface IPackage {
    BasePackagePrice: number;
    RemainingTrialDays: number;
    BillingText: string;
    HasUserCancelled: boolean;
    IsActive: boolean;
    IsPacakgeUpgradable: boolean;
    IsPackageCancel: boolean;
    PackagId: number;
    PackageCode: string;
    PackageName: string;
    PackagePrice: number;
    PackagePriceYearly: number;
    DisplayPrice?: boolean;
    SubcriptionType: string;
    PartnerId?: number;
    PartnerName?: string;
    PackageForCacellationContinuation?: boolean;
    Products?: IProduct[];
    ShowCrossOut?: boolean;
    YearlySavingPrice?: string;
    BasePackagePriceYearly?: number;
    IsPSS?: boolean;
    IsUserPaid?: boolean;
    IsBusinessUser?: boolean;
    ProvidedBy?: string;

    // Properties for UI logic
    DisplayPaymentInfo?: boolean;
    ShowSubscriptionTypeChangeText?: boolean;
    ActionButtonText?: string;
    ShowBillingText?: boolean;
    Price?: number;
    PackageValue?: number;
    PacakgeType:string;
}

export type ProtectionPlanTypes = IRequestProtectionPlanAction | IReceiveProtectionPlanAction;

export interface IProtectionPlanResponse {
    IsIDFUser?: boolean;
    packageList?: IPackage[];
    productList?: IProduct[];
}

//==================================CheckContractChangeState====================================================================

export interface ICheckContractChangeState {
    checked: boolean;
    fromRedirectUrl?: boolean;
    contractChangeData?: IContractChangeResponse;
    cancellatinoContinuationData?: ICancellationContinuationResponse;
}
export const RECEIVE_CONTRACT_CHANGE = "RECEIVE_CONTRACT_CHANGE";
export interface IReceiveContractChange {
    type: typeof RECEIVE_CONTRACT_CHANGE;
    data: IContractResponse;
}

export interface IContractResponse {
    contractChangeData?: IContractChangeResponse;
    cancellatinoContinuationData?: ICancellationContinuationResponse;
    fromRedirectUrl?: boolean;
}
export interface IContractChangeResponse {
    ContractStatus: string;
    RemovedServiceList?: any;
    IsPaymentAdjusted: boolean;
    AddedServiceList?: any;
    PackageInfo?: any;
    PackageName?: string;
    GlobalOffercodeText?: string;
    BtnCancellationContinuationAcceptText?: string;
}

export interface ICancellationContinuationResponse {
    ContractStatus: string;
    IsPaymentAdjusted: boolean;
    PackageInfo?: any;
    PackageName?: string;
    GlobalOffercodeText?: string;
    ServiceList?: any;
    BtnCancellationContinuationAcceptText?: string;
    IsOffercodeApplied: boolean;
    OfferPrice: any;
}
